import { z } from 'zod';
import { SkillNameSchema, SourceSchema } from './common.schema';

const BackgroundFeatureSchema = z.object({
  name: z.string(),
  description: z.string(),
});

const SuggestedCharacteristicsSchema = z.object({
  personalityTraits: z.array(z.string()),
  ideals: z.array(z.string()),
  bonds: z.array(z.string()),
  flaws: z.array(z.string()),
});

export const BackgroundSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  skillProficiencies: z.array(SkillNameSchema),
  toolProficiencies: z.array(z.string()),
  languages: z.number(),
  equipment: z.array(z.string()),
  feature: BackgroundFeatureSchema,
  suggestedCharacteristics: SuggestedCharacteristicsSchema,
  source: SourceSchema,
});

export type BackgroundData = z.infer<typeof BackgroundSchema>;
